import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const PersonOutline = ({ ...rest }: SvgProps) => (
  <svg
    width="241"
    height="241"
    viewBox="0 0 241 241"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_person)">
      <rect width="241" height="241" fill="#FDFD92" />
      <circle cx="121" cy="95" r="47" fill="#D3C4AC" />
      <ellipse cx="121" cy="241" rx="98" ry="92" fill="#D3C4AC" />
    </g>
    <defs>
      <clipPath id="clip0_person">
        <rect width="241" height="241" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PersonOutline;
